const TOKEN_AUTH = 'APP_TOKEN_AUTH'
const SET_ACCOUNT = 'APP_SET_ACCOUNT'
const LOADING_USER = 'APP_LOADING_USER'
const IMPERSONATE = 'IMPERSONATE'
const SWITCH_COMPANY = 'SWITCH_COMPANY'
const TOKEN_OAUTH = 'GOOGLE_TOKEN_OAUTH'

export {
  TOKEN_AUTH,
  SET_ACCOUNT,
  LOADING_USER,
  IMPERSONATE,
  SWITCH_COMPANY,
  TOKEN_OAUTH,
}

const initialState = {
  loading_user: false,
  token: null,
  impersonate_data: JSON.parse(
    localStorage.getItem('impersonate_data') ?? '{}'
  ),
  idToken: null,
  current_locale: 'fr_FR',
  user: null,
  roles: null,
  currentCompany: null,
  currentRole: null,
  companiesHistory: [],
  googleUser: JSON.parse(localStorage.getItem('google_data') ?? '{}'),
}

export default function (
  state = {
    ...initialState,
  },
  action = {}
) {
  switch (action.type) {
    case LOADING_USER:
      return {
        ...state,
        loading_user: action.loading !== null && action.loading !== undefined ? action.loading : true,
      }
    case TOKEN_AUTH:
      return {
        ...state,
        token: action.keycloak_data.token,
        idToken: action.keycloak_data.idToken,
        roles: action?.keycloak_data?.roles ?? null,
      }
    case TOKEN_OAUTH:
      return {
        ...state,
        googleUser: action.data,
      }
    case IMPERSONATE:
      return {
        ...state,
        impersonate_data: action.impersonate_data,
      }
    case SET_ACCOUNT:
      return {
        ...state,
        user: action.data,
        current_locale: action.data.culture,
        currentCompany: action.data.companies?.length === 1 ? action.data.company : undefined,
        companiesHistory: (action.data.companies ?? []).map((c) => c.company),
      }
    case SWITCH_COMPANY: {
      let companiesHistory = state.companiesHistory

      if (action?.data?.id) {
        const hasCompany = companiesHistory.findIndex(
          (company) => company.id === action?.data?.id
        )

        if (hasCompany === -1) {
          companiesHistory.splice(0, 0, action?.data)
          companiesHistory = companiesHistory.slice(0, 5)
        } else if (hasCompany > 0) {
          const element = companiesHistory[hasCompany]
          companiesHistory.splice(hasCompany, 1)
          companiesHistory.splice(0, 0, element)
        }
      }

      return {
        ...state,
        currentCompany: action.data,
        companiesHistory,
        currentRole: action.currentRole,
      }
    }
    default:
      return state
  }
}
